"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollCommand = void 0;
const Command_1 = require("../Command");
const CommandType_1 = require("../lib/CommandType");
/**
 * Multiplies the default scrolling speed by this value. Changes how the notes
 * appear on the screen, values above 1 will make them scroll faster and below 1
 * scroll slower. Negative values will scroll notes from the left instead of the
 * right. Cannot be 0. Can be placed in the middle of a measure.
 *
 * **Example:**
 *
 * ```
 *  #SCROLL 4
 * 30
 * #SCROLL 0.5
 * 11201022112010,
 * ```
 */
class ScrollCommand extends Command_1.Command {
    constructor(value) {
        super(CommandType_1.CommandType.Scroll);
        this.value = value;
    }
    static parse(args) {
        if (args.length === 0) {
            return undefined;
        }
        const value = parseFloat(args[0]);
        if (isNaN(value)) {
            return undefined;
        }
        return new ScrollCommand(value);
    }
    toString() {
        return `${super.toString()} ${this.value}`;
    }
}
exports.ScrollCommand = ScrollCommand;
